// Anonymous funnel events for the portfolio analytics collector.
// Sends aggregate-count events only: no cookies, no user identifiers,
// so it works without analytics consent (nothing personal is processed).

const getApiBase = () => {
  const g = (process.env.REACT_APP_GRAPHQL_ENDPOINT || '').trim()
  if (g) return g.replace(/\/graphql\/?$/i, '').replace(/\/$/, '')
  return 'https://api.weestoryworld.com'
}

let experimentId = null
fetch('/experiment.json')
  .then((r) => (r.ok ? r.json() : null))
  .then((data) => {
    if (data?.id) experimentId = String(data.id)
  })
  .catch(() => {})

const withExperiment = (payload) => {
  if (!experimentId) return payload
  return { ...(payload || {}), experiment_id: experimentId }
}

/**
 * Fire-and-forget funnel event. Allowed events (see backend analytics app):
 * app_loaded, signup_started, signup_completed, paywall_seen,
 * checkout_started, checkout_succeeded, first_output, waitlist_join
 */
export const track = (event, payload) => {
  try {
    const body = payload
      ? { event, payload: withExperiment(payload) }
      : experimentId
        ? { event, payload: { experiment_id: experimentId } }
        : { event }
    fetch(`${getApiBase()}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {})
  } catch (e) {
    // Analytics must never break the app.
  }
}

export default track
